import { useSelector } from 'react-redux';

import { brandSelector } from '@/domains/productDiscovery/ProductPage/modules/Brand/brand.ducks';

export const useBrand = () => useSelector(brandSelector);
